import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatTableDataSource, MatDialog } from '@angular/material';
import * as  moment from 'moment';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { EditalDTO } from '../../model/dto/edital.dto';
import { EditalService } from '../../service/edital/edital.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { ModalAtualizacaoFormComponent } from '../../components/modal-atualizacao-form/modal-atualizacao-form.component';
import { DocumentoDTO } from 'src/app/model/dto/documento.dto';
import { ToasterService } from 'angular2-toaster';
import { DocumentoService } from 'src/app/service/documento.service';


@Component({
  selector: 'app-cadastrar-edital',
  templateUrl: './cadastrar-edital.component.html',
  styleUrls: ['./cadastrar-edital.component.css'],
 
})
export class CadastrarEditalComponent implements OnInit {

  editalForm: FormGroup;
  anexo: File;
  anexo64: String;
  ELEMENT_DATA: EditalDTO[] = [];
  MY_FORMATS = {
    parse: {
      dateInput: 'DD/MM/YYYY',
    },
    display: {
      dateInput: 'DD/MM/YYYY',
      monthYearLabel: 'MM YYYY',
      dateA11yLabel: 'DD/MM/YYYY',
      monthYearA11yLabel: 'MM YYYY',
    },
  };
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayedColumns: string[] = ['nomeEdital', 'periodo', 'anoOrcamento', 'acoes'];
  dataSource = new MatTableDataSource<EditalDTO>(this.ELEMENT_DATA);
  date: string;
  edital: EditalDTO[];
  dataInicio: string;
  minDate =  new Date();
  constructor(private fb: FormBuilder,
    private editalService: EditalService,
    public dialog: MatDialog,
    private toastService: ToasterService,
    private documentoService: DocumentoService) {  }

  ngOnInit() {
    this.montarForm();
    this.dataSource.paginator = this.paginator;
    this.limpar();
    this.buscarEditaisAtivos();    
  }
  
  montarForm(){
    this.editalForm = this.fb.group({
      nomeEdital: new FormControl('',Validators.required),
      periodoInicio: new FormControl('',Validators.required),
      periodoFim: new FormControl('',Validators.required),  
      dataDistribuicao: new FormControl('',Validators.required),  
    });
  }

  buscarEditaisAtivos() {
    this.editalService.buscarEdital(0).subscribe(({data}) => {
      this.dataSource.data = data;
      this.dataSource.data = this.dataSource.data;
    })
  }

  cadastrar(){    
    if (!this.editalForm.valid) {
      Swal.fire({
        text: 'Preencha todos os campos para finalizar o cadastro',
        showClass: {
          popup: 'animate__animated animate__fadeInDown'
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp'
        },
        icon: 'info',
      });
      return;
    }

    if (this.anexo == null) {
      Swal.fire({
        text: 'É necessário anexar um arquivo para finalizar o cadastro',
        showClass: {
          popup: 'animate__animated animate__fadeInDown'
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp'
        },
        icon: 'info',
      });
      return;
    }

    const edital = new EditalDTO();
    edital.nomeEdital = this.editalForm.get('nomeEdital').value;
    edital.periodoInicio = this.editalForm.get('periodoInicio').value;
    edital.periodoFim = this.editalForm.get('periodoFim').value;
    edital.dataDistribuicao = this.editalForm.get('dataDistribuicao').value;
    edital.anexoEdital = this.anexo64;  
    edital.nomeAnexo = this.anexo.name;
    
    if(this.verificarPeriodoValido(edital).length > 0) {
      Swal.fire({
        text: 'Já existe um edital vigente para esse período',
        showClass: {
          popup: 'animate__animated animate__fadeInDown'
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp'
        },
        icon: 'info',
      });

      return;
    }
    edital.periodoInicio = moment(edital.periodoInicio).locale('en').format('YYYY-MM-DD');
    edital.periodoFim = moment(edital.periodoFim).locale('en').format('YYYY-MM-DD');
    edital.dataDistribuicao = moment(edital.dataDistribuicao).locale('en').format('YYYY-MM-DD');
    this.editalService.cadastrarEdital(edital).subscribe(retorno => {
      this.dataSource.data.push(retorno.data);
      this.dataSource.data = this.dataSource.data.sort((a, b) => a > b ? 1 : -1);
      Swal.fire({
        text:  'Edital salvo com sucesso.',
        icon: 'info',
      });
    },
    error => {
      if(error.status == 400){
        Swal.fire({
          text:  'Não foi possível cadastrar o Edital.',
          icon: 'error',
        });  
      } 
    });
    this.limpar();
  }

  atualizar(edital){
      this.dialog.open(ModalAtualizacaoFormComponent,{
        width: '40%',
        data: {
          edital: edital
        }
      }).afterClosed().subscribe(retorno => {
        this.buscarEditaisAtivos();
    });
  }

  inativar(edital) {
    this.editalService.inativar(edital.id).subscribe(({data}) => {
      if (data !== null) {
        Swal.fire({
          text:  'Edital inativado.',
          icon: 'success',
        });
        this.buscarEditaisAtivos();
      }
    });
  }

  limpar() {
    this.editalForm.reset();
    this.anexo = null;
  }

  validarDataFim(event) {
    //moment(event.targetElement.value,'DD/MM/YYYY').locale('en-ca').format('L');
    // console.log(event.targetElement.value);
    // console.log(moment(event.targetElement.value,'DD/MM/YYYY').isBefore(moment(this.dataInicio,'DD/MM/YYYY')))
    if (moment(event.targetElement.value,'DD/MM/YYYY').isBefore(moment(this.dataInicio,'DD/MM/YYYY'))) {
      Swal.fire({
        text:  'Período Inválido',
        icon: 'error',
      });
      this.editalForm.get('periodoFim').setValue('');
      return;
    }
  }

  validarDataInicio(event) {
    this.dataInicio = event.targetElement.value;
  }

  private verificarPeriodoValido(editalDto: EditalDTO) {
    const perido = this.dataSource.data.map(edital => moment(editalDto.periodoInicio).isBetween(edital.periodoInicio, edital.periodoFim));
    const existe = perido.filter(perido => perido === true);
    if (existe.length === 0) {
      const isSame = this.dataSource.data.map(edital => moment(editalDto.periodoInicio).isSame(edital.periodoInicio));
      return isSame.filter(perido => perido === true);
    }
    return existe;
  }

  selecionarAnexo(event) {
    this.anexo = event.target.files[0];

    if (this.anexo.type != 'application/pdf') {
      this.toastService.pop('warning', 'Formato inválido. Formato permitido PDF');
      this.anexo = null;
      return;
    }

    if (this.anexo.size > 5000000) {
      this.toastService.pop('warning', 'Tamanho do anexo excede o limite permitido');
      this.anexo = null;
      return;
    }
    this.encodeAnexo(this.anexo);
    (event.target as HTMLInputElement).value = null;
  }

  desanexarArquivo() {
    this.anexo = null;
    this.anexo64 = null;
  }

  private encodeAnexo(anexo : File) {
    var rd = new FileReader();
    if (anexo != null) {

      rd.readAsDataURL(anexo);
      rd.onload = () => {
        this.anexo64 = rd.result.toString().split(',')[1];
      }

      rd.onerror = (error) => {
        this.anexo64 = "";
      }
    }
  }

  private download(edital) {
    this.documentoService.downloadTermo(edital.id)
    .subscribe(data => this.downloadFile(data),
    error => {
      if (error.status == 400) {
        Swal.fire({
          text:  'Termo de Adesão não encontrado',
          icon: 'error',
        });  
      }
    }); 
  }

  downloadFile(data) {
    const newBlob = new Blob([data], { type: "application/pdf" });
    const url= window.URL.createObjectURL(newBlob);
    window.open(url);
  }
}
